import type {Auth, Exemplar} from 'typings/portaro.be.types';
import bind from 'bind-decorator';
import {getFirstById} from 'shared/utils/array-utils.fp';

export type ExemplarFilterFunction = (exemplar: Exemplar) => boolean;

export default class ExemplarFilter {

    constructor(private showableExemplarStatuses: number[]) {
    }

    @bind
    forUser(auth?: Auth): ExemplarFilterFunction {
        return (exemplar: Exemplar) => {
            if (auth) {
                if (auth.role.includes('ROLE_ADMIN')) {
                    return true;
                }

                if (getFirstById(exemplar.department.id)(auth.editableDepartments)) {
                    return true;
                }
            }

            return this.showableExemplarStatuses.includes(exemplar.status.id);
        };
    }

    public get anonymous(): ExemplarFilterFunction {
        return this.forUser();
    }
}